import { useDialogState } from "../../../../hooks/use-dialog-state/UseDialogState";
import { UserEditorDialogState } from "./UserEditorDialog";

export function useUserEditorDialogState(): UserEditorDialogState {
    return useDialogState();
}
